import React from 'react';
import { Button, Icon } from 'semantic-ui-react';
import { LatestDocusignSendSummaryDto } from '../../services/contracts/ContractService';
import { getDocusignSummaryLines } from '../../utils/docusignSendHistoryUtils';

interface DocusignSendSummaryBlockProps {
  summary: LatestDocusignSendSummaryDto;
  footerText?: string;
}

const DocusignSendSummaryBlock: React.FC<DocusignSendSummaryBlockProps> = ({ summary, footerText }) => {
  const lines = getDocusignSummaryLines(summary);

  return (
    <>
      {lines.length > 0 && (
        <p style={{ whiteSpace: 'pre-line', margin: 0 }}>{lines.join('\n')}</p>
      )}
      {summary.docusignContractLink && (
        <Button
          as="a"
          href={summary.docusignContractLink}
          target="_blank"
          rel="noreferrer"
          size="small"
          primary
          style={{ marginTop: '8px' }}
        >
          <Icon name="external alternate" />
          Abrir no DocuSign
        </Button>
      )}
      {footerText && (
        <p style={{ marginTop: '8px', marginBottom: 0 }}>{footerText}</p>
      )}
    </>
  );
};

export default DocusignSendSummaryBlock;
